"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactIntl = require("react-intl");
var _clsx = _interopRequireDefault(require("clsx"));
var _Close = _interopRequireDefault(require("@quintoandar/cozy-icons/Close"));
var _Alert = require("./Alert.types");
var _IconButton = _interopRequireDefault(require("../IconButton"));
var _Typography = _interopRequireDefault(require("../Typography"));
var _IconButton2 = require("../IconButton/IconButton.types");
var _Typography2 = require("../Typography/Typography.types");
var _InternationalMessage = require("../type-tools/InternationalMessage");
var _logService = require("../tools/service/log/logService");
var _constants = require("./constants");
var _Alert2 = require("./Alert.utils");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) {
    if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
      var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
      i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
    }
  }
  return n["default"] = e, t && t.set(e, n), n;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0) {
        ;
      }
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
var styles = {
  "show": "-icSie",
  "showResize": "pb-1M6",
  "hide": "lGlaDN",
  "hideResize": "CitUW8",
  "alert": "_4JY35d",
  "critical": "_2GwLrE",
  "default": "KkYq60",
  "positive": "JRUQuZ",
  "warning": "iyRiJU",
  "information": "h0CRIz",
  "content": "YY2D-T",
  "closeButtonWrapper": "woPTq8"
};
var Alert = function Alert(_ref) {
  var kind = _ref.kind,
    Icon = _ref.icon,
    titleProps = _ref.title,
    ariaLabelProps = _ref.ariaLabel,
    children = _ref.children,
    transitionOnLoad = _ref.transition,
    onClose = _ref.onClose,
    closeButtonAriaLabelProps = _ref.closeButtonAriaLabel,
    dataTestid = _ref['data-testid'];
  var _useInternationalMess = (0, _InternationalMessage.useInternationalMessages)(titleProps, ariaLabelProps, closeButtonAriaLabelProps),
    _useInternationalMess2 = _slicedToArray(_useInternationalMess, 3),
    title = _useInternationalMess2[0],
    ariaLabel = _useInternationalMess2[1],
    closeButtonAriaLabel = _useInternationalMess2[2];
  if (title.length > 20) {
    (0, _logService.logSpecificErrorMessage)("ALERT", 'Title must be up to 20 characters (including spaces)');
  }
  if (kind !== _Alert.Kind.INFORMATION && Icon) {
    (0, _logService.logSpecificErrorMessage)("ALERT", 'Only for information kind is it allowed to customize the icon');
  }
  var isDismissible = kind === _Alert.Kind.DEFAULT || kind === _Alert.Kind.POSITIVE;
  var hasButtonDismissible = isDismissible && onClose;
  var intl = (0, _reactIntl.useIntl)();
  var _useState = (0, _react.useState)(0),
    _useState2 = _slicedToArray(_useState, 2),
    alertRefHeight = _useState2[0],
    setAlertRefHeight = _useState2[1];
  var alertRef = /*#__PURE__*/(0, _react.createRef)();
  (0, _react.useEffect)(function () {
    setAlertRefHeight(alertRef.current.clientHeight);
  }, [alertRef, alertRefHeight]);
  var _useState3 = (0, _react.useState)(null),
    _useState4 = _slicedToArray(_useState3, 2),
    currentTransition = _useState4[0],
    setTransition = _useState4[1];
  var handleOnClose = function handleOnClose() {
    if (typeof onClose === 'boolean') {
      setTransition('hide');
    }
    if (typeof onClose === 'function') {
      onClose();
    }
  };
  (0, _react.useEffect)(function () {
    if (transitionOnLoad) {
      setTransition(transitionOnLoad);
    }
  }, [transitionOnLoad, currentTransition]);
  var _KIND_MAP$kind = _constants.KIND_MAP[kind],
    a11yProps = _KIND_MAP$kind.a11yProps,
    _KIND_MAP$kind$icon = _KIND_MAP$kind.icon,
    Component = _KIND_MAP$kind$icon.component,
    iconTitle = _KIND_MAP$kind$icon.iconTitle,
    htmlColor = _KIND_MAP$kind$icon.htmlColor;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])('Cozy-AlertAnimation', (0, _Alert2.getClassName)(currentTransition)),
    style: {
      '--alert-height': "".concat(alertRefHeight, "px")
    }
  }, /*#__PURE__*/_react["default"].createElement("section", _extends({}, a11yProps, {
    className: (0, _clsx["default"])('Cozy-Alert', styles.alert, styles[kind]),
    "aria-label": ariaLabel || title,
    role: "status",
    "data-testid": dataTestid // TODO: Remove these props in the future: added it to keep support to old API id test selection
    ,

    ref: alertRef
  }), kind === _Alert.Kind.INFORMATION && Icon ? /*#__PURE__*/_react["default"].createElement(Icon, {
    htmlColor: htmlColor
  }) : /*#__PURE__*/_react["default"].createElement(Component, {
    title: intl.formatMessage(iconTitle),
    htmlColor: htmlColor
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.content
  }, title && /*#__PURE__*/_react["default"].createElement(_Typography["default"], {
    level: _Typography2.Level.BODY_STRONG,
    kind: _Typography2.Kind.DEFAULT
  }, title), children), hasButtonDismissible && /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _clsx["default"])('Cozy-AlertCloseButtonWrapper', styles.closeButtonWrapper)
  }, /*#__PURE__*/_react["default"].createElement(_IconButton["default"], {
    className: "Cozy-AlertCloseButton",
    size: _IconButton2.Size.SMALL,
    icon: _Close["default"],
    "aria-label": closeButtonAriaLabel,
    onClick: handleOnClose
  }))));
};
Alert.propTypes = process.env.NODE_ENV !== "production" ? {
  kind: _propTypes["default"].oneOf(Object.values(_Alert.Kind)),
  icon: _propTypes["default"].elementType,
  title: _InternationalMessage.InternationalizableMessagePropType,
  ariaLabel: _InternationalMessage.InternationalizableMessagePropType,
  children: _propTypes["default"].node,
  onClose: _propTypes["default"].oneOfType([_propTypes["default"].func, _propTypes["default"].bool]),
  closeButtonAriaLabel: _InternationalMessage.InternationalizableMessagePropType,
  transition: _propTypes["default"].oneOf(Object.values(_Alert.Transition)),
  'data-testid': _propTypes["default"].string // TODO: Remove these props in the future: added it to keep support to old API id test selection
} : {};
Alert.defaultProps = {
  kind: _Alert.Kind.DEFAULT
};
var _default = exports["default"] = Alert;